import React from 'react';

function Poroke(){
   	
  	return(
  		<div>
  			<div className = "row" style = {{ padding: "2em 0" }}>
				<img src = "/slike/glave/krsti.jpg" className = "img-responsive" alt = "krsti" />
			</div>
			<div className = "row text-center" style = {{ padding: "0 6em" }}>
				<h2 className = "naslovi" style = {{ padding: "0 0 1em 0" }}> SVETI ZAKON </h2>
				<p>
					Vsaj tri mesece (zaželeno pol leta) pred sklenitvijo zakonske zveze se
					ženin in nevesta oglasita osebno v času uradnih ur v župnijskem uradu na
					naslovu Raspov prehod 2, Kamnik. Namen srečanja je seznanitev s pogoji
					za veljavno sklenitev zakonske zveze, uskladitev časa in kraja poročne
					slovesnosti, določitev datuma sestavljanja poročnega zapisnika in
					pravočasne priprave na zakon. Če za poroko izbereta župnijsko cerkev sv.
					Ane v Tunjicah, se tega z vama veselimo, ter se tudi že vnaprej
					zahvaljujemo za prispevek-dar za vzdrževanje in urejanje cerkve (rečemo
					več na srečanju).
				</p>
				<p>
					Pripravo na zakon je mogoče opravljati tudi v župniji Kamnik. Ta poteka
					februarja in septembra. Organizirana je v obliki štirih zaporednih
					srečanj, in sicer dve soboti in dve nedelji. Več si lahko preberete na <a href="https://zupnija-kamnik.rkc.si/index.php/content/display/1875/priprava%20na%20zakon/20" target="_blank" rel="noopener noreferrer">spletni strani župnije Kamnik</a> ali na spletni strani škofije, (objavljeni
					tudi <a href="https://nadskofija-ljubljana.si/druzina/priprava-na-krscanski-zakon/" target="_blank" rel="noopener noreferrer">termini priprave na zakon drugod</a>).
				</p>
				<p>
					Blagoslovljen čas priprave in skupno pot drug z drugim in z Gospodom
					skozi življenje želimo.
				</p>
			</div>
  		</div>
	)
}

export default Poroke;